import axios from 'axios'

export const SendUserData = (data) => {

    if(data.click_id){

        let userData = {
            click_id: data.click_id,
            age: data.age,
            sex: data.sex,
            weight: data.weight,
            height: data.height,
            email: data.email
        }

        let encodedUserData = btoa(JSON.stringify(userData))

        axios.post('/landing/collect', encodedUserData)
        
    }
}